import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { UIConfigWithDatepicker } from '../shared/UIConfigWithDatepicker/UIConfigWithDatepicker'

export default function AncillaryServices(): ReactElement {
  const { t } = useTranslation()

  return <UIConfigWithDatepicker type="ancillary_services" title={t('Ancillary services')} defaultDay="today" />
}
